export default "__VITE_ASSET__B2QJT8Kp__"